var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import Dialog from 'nucleus-core/dialog/Dialog';
import AnimationUpStyles from 'nucleus-core/less/cv/Dialog.transitionUp.less';
import DialogStyles from 'nucleus-core/less/cv/Dialog.less';
import PropTypes from 'prop-types';
import ThemeableComponent from 'nucleus-widgets/lib/ThemeableComponent';
var CCPAOptOutDialog = /** @class */ (function (_super) {
    __extends(CCPAOptOutDialog, _super);
    function CCPAOptOutDialog() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CCPAOptOutDialog.prototype.render = function () {
        var _a = this.props, isOpen = _a.isOpen, isModal = _a.isModal, header = _a.header, isFixedHeader = _a.isFixedHeader, classes = _a.classes, style = _a.style;
        var CCPADialogStyle = __assign(__assign({}, DialogStyles), { content: classes.content, transition: AnimationUpStyles });
        var headerStyle = __assign(__assign({}, style.headerFont), style.header);
        var popUpDialogConfig = {
            requestClose: this.props.handleDialogClose,
            dialogId: 'CCPAOptOutDialog',
            isOpen: isOpen,
            isModal: isModal,
            header: header,
            isFixedHeader: isFixedHeader,
            closeDialogOnOverlayClick: true,
            style: __assign(__assign({}, style), { header: headerStyle }),
            classes: CCPADialogStyle
        };
        return (React.createElement("div", { id: "OptOutDialog" },
            React.createElement(Dialog, __assign({}, popUpDialogConfig), this.props.children)));
    };
    CCPAOptOutDialog.displayName = 'CCPAOptOutDialog';
    CCPAOptOutDialog.propTypes = {
        isOpen: PropTypes.bool,
        isModal: PropTypes.bool,
        header: PropTypes.string,
        isFixedHeader: PropTypes.bool,
        isFullScreen: PropTypes.bool,
        children: PropTypes.node,
        translate: PropTypes.func,
        handleDialogClose: PropTypes.func,
        style: PropTypes.object,
        classes: PropTypes.object
    };
    return CCPAOptOutDialog;
}(ThemeableComponent));
export default CCPAOptOutDialog;
